<div class="empty-state" *ngIf="!($loading | async) && (codes | async) && !(codes | async)?.length">

  <h2>No Trackable links or QR Codes found</h2>
  <p>You need to create one in order to {{type === 'event' ? 'sell tickets' : 'collect donations'}}</p>

  <button class="btn btn-sm btn-theme" (click)="addCode()">Get Started</button>

</div>

<div class="code-list" *ngIf="!($loading | async) && (codes | async) && (codes | async)?.length">

  <div class="d-flex align-items-center mb-4">
    <h2 class="m-0">Your Codes</h2>
    <button class="btn btn-sm btn-theme ms-auto" (click)="addCode()">Add code</button>
  </div>


  <div class="single-code" *ngFor="let code of (codes | async)">

    <div class="icon-container" *ngIf="code.link_only">
      <i class="fi fi-br-link"></i>
    </div>

    <div class="icon-container" *ngIf="!code.link_only" (click)="enlargeQR(code)">
      <img [src]="generateQRImage(code)" alt="QR Code">
    </div>

    <div class="code-info">
      <h6 *ngIf="code.link_only">Shareable Link</h6>
      <h6 *ngIf="!code.link_only && !code.loc">Static QR Code</h6>
      <h6 *ngIf="!code.link_only && code.loc">Trackable QR Code</h6>
      <p *ngIf="!code.link_only && code.loc">{{code.loc.coordinates[0]}}, {{code.loc.coordinates[1]}}</p>
    </div>

    <div class="code-actions text-right">
      <button class="btn btn-sm btn-theme-secondary" *ngIf="!code.link_only" (click)="enlargeQR(code)">View code</button>
      <app-copy-button class="btn btn-sm btn-theme-secondary" *ngIf="code.link_only" [content]="code.id | sharedLink">Copy Link</app-copy-button>
    </div>

  </div>

</div>
